import axiosLib, { AxiosError } from 'axios'

import SessionError from './session_error'

export interface APIErrorResponse {
  status: number
  type: string
  message: string
}

export const axios = axiosLib.create({
  baseURL: '/api',
  timeout: 2 * 60 * 1000,
  validateStatus: status => {
    return status >= 200 && status <= 504
  }
})

export function isClientAPIError<T = APIErrorResponse, D = any>(payload: any): payload is AxiosError<T, D> {
  return axiosLib.isAxiosError(payload)
}

const errCatchHandler = (err: any) => {
  if (!isClientAPIError(err)) {
    // 本来はスローがいいけど既存がバグるのでreturn
    return err
  }

  if (err.response && err.response.status === 401) {
    SessionError.showNotify()
  }
  return err
}

/**
 * SEND GET API
 */
async function get<T = any>(endpoint: string, options?: any): Promise<T> {
  try {
    const response = await axios.get<T>(endpoint, options)

    if (response.status === 401) {
      SessionError.showNotify()
    }
    return response.data
  } catch (err) {
    return errCatchHandler(err)
  }
}

/**
 * SEND POST API
 */
async function post<T = any, P = any>(endpoint: string, params: P, options?: any): Promise<T> {
  try {
    const response = await axios.post<T>(endpoint, params, options)

    if (response.status === 401) {
      SessionError.showNotify()
    }
    return response.data
  } catch (err) {
    return errCatchHandler(err)
  }
}

/**
 * SEND PUT API
 */
async function put<T = any, P = any>(endpoint: string, params: P, options?: any): Promise<T> {
  try {
    const response = await axios.put<T>(endpoint, params, options)
    if (response.status === 401) {
      SessionError.showNotify()
    }
    return response.data
  } catch (err) {
    return errCatchHandler(err)
  }
}

/**
 * SEND DELETE API
 */
async function sendDelete<T = any>(endpoint: string, options?: any): Promise<T> {
  try {
    const response = await axios.delete<T>(endpoint, options)
    if (response.status === 401) {
      SessionError.showNotify()
    }
    return response.data
  } catch (err) {
    return errCatchHandler(err)
  }
}

export default {
  get,
  post,
  put,
  delete: sendDelete
}
